import React from 'react';
import styled, { css } from 'styled-components';
import { Box, IconButton, Text } from '@sparknz/spark-pattern-library';
import { trackCustomLink } from '@sparknz/tracking';

interface PlanQuantitySelectorProps {
  quantity: number;
  onIncrease(): void;
  onDecrease(): void;
  disabled?: boolean;
  suffix?: string;
  minQuantity?: number;
  maxQuantity?: number;
}

const Container = styled(Box)`
  ${({ theme: { palette } }) => css`
    border-top: 1px solid ${palette.baseColors.alto};
    border-bottom: 1px solid ${palette.baseColors.alto};
  `}
`;

const DEFAULT_MINIMUM_QUANTITY = 1;

const PlanQuantitySelector = ({
  quantity,
  onIncrease,
  onDecrease,
  disabled,
  suffix = '',
  minQuantity = DEFAULT_MINIMUM_QUANTITY,
  maxQuantity,
}: PlanQuantitySelectorProps) => {
  const handleIncrease = () => {
    if (maxQuantity && quantity >= maxQuantity) {
      return;
    }

    trackCustomLink('Increase');
    onIncrease();
  };

  const handleDecrease = () => {
    if (quantity > minQuantity) {
      trackCustomLink('Decrease');
      onDecrease();
    }
  };

  return (
    <Container
      mb="s4"
      py="s2"
      flexDirection="row"
      alignItems="center"
      justifyContent="space-between"
    >
      <IconButton
        title="Decrease"
        icon="minus_small"
        onClick={handleDecrease}
        disabled={disabled || quantity <= minQuantity}
        aria-label="Decrease quantity"
      />

      <Text variant="bodySMedium">
        {quantity} {suffix}
      </Text>

      <IconButton
        title="Increase"
        icon="plus_small"
        onClick={handleIncrease}
        disabled={disabled || !!(maxQuantity && quantity >= maxQuantity)}
        aria-label="Increase quantity"
      />
    </Container>
  );
};

export default PlanQuantitySelector;
